import { StateCreator } from 'zustand';

export interface PromoCodeSlice {
  promoCode?: string;
  setPromoCode: (promoCode?: string) => void;
  promoCodeError?: string;
  setPromoCodeError: (promoCodeError?: string) => void;
  triggerPromoCode?: string;
  setTriggerPromoCode: (triggerPromoCode?: string) => void;
}

export const createPromoCodeSlice: StateCreator<PromoCodeSlice, [], [], PromoCodeSlice> = (set) => ({
  promoCode: undefined,
  setPromoCode: (promoCode?: string) => set({ promoCode }),
  promoCodeError: undefined,
  setPromoCodeError: (promoCodeError?: string) => set({ promoCodeError }),
  triggerPromoCode: undefined,
  setTriggerPromoCode: (triggerPromoCode?: string) => set({ triggerPromoCode }),
});
